const DASHBOARD_CONSTANTS = {
  DASHBOARD: 'Dashboard',
  DASHBOARD_HIGHLIGHTS: 'Dashboard/Highlights',
  DASHBOARD_PROMOTIONS: 'Dashboard/Promotions',
  DASHBOARD_TRADERS: 'Dashboard/Traders',
  DASHBOARD_DEMO: 'Dashboard/Demo',
};
export default DASHBOARD_CONSTANTS;
